import { render, staticRenderFns } from "./solutionDebtInfoDebtor.vue?vue&type=template&id=5f36897b&"
import script from "./solutionDebtInfoDebtor.vue?vue&type=script&lang=js&"
export * from "./solutionDebtInfoDebtor.vue?vue&type=script&lang=js&"
import style0 from "./solutionDebtInfoDebtor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports